export type RegistriaUserErrorResponse = {
  message?: string;
};
